import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Layout, Menu, Button, Drawer } from 'antd';
// MUI v4 Button for the dialogs. The antd Button ignores startIcon and brings
// its own box model, which is why the icon and padding sat wrong there.
import MuiButton from '@material-ui/core/Button';
import Switch from '@material-ui/core/Switch';
import CheckIcon from '@material-ui/icons/Check';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import {
  MenuUnfoldOutlined, ReadOutlined, ReconciliationOutlined,
  MenuFoldOutlined, BankOutlined, CalendarOutlined, FileDoneOutlined,
  CalculatorOutlined, ShoppingCartOutlined, ShopOutlined, RocketOutlined, BarcodeOutlined,
  DashboardOutlined, UploadOutlined, DiffOutlined, UserOutlined,
  BarsOutlined, AuditOutlined, WhatsAppOutlined, GiftOutlined, CarryOutOutlined, HomeOutlined,
  FileTextOutlined, FolderViewOutlined, SignalFilled, SettingOutlined, ControlOutlined, PhoneOutlined,
  CustomerServiceOutlined, IdcardOutlined, UsergroupAddOutlined, EnvironmentOutlined, CrownOutlined,
  CloseOutlined, CopyOutlined, FileSyncOutlined, FieldTimeOutlined, NotificationOutlined, QrcodeOutlined,
  BellOutlined
} from '@ant-design/icons';
import DialogContentText from '@material-ui/core/DialogContentText';
import { NavLink, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import { useHistory } from 'react-router-dom';
// Import other components
import ScannerIcon from '@material-ui/icons/Scanner';
import MenuBookIcon from '@material-ui/icons/MenuBook';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import BallotIcon from '@material-ui/icons/Ballot';
import AssignmentLateRoundedIcon from '@material-ui/icons/AssignmentLateRounded';
import FaceIcon from '@material-ui/icons/Face';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import EqualizerIcon from '@material-ui/icons/Equalizer';
import LocalLibraryIcon from '@material-ui/icons/LocalLibrary';
import NotificationsNoneIcon from '@material-ui/icons/NotificationsNone';
import NotificationsIcon from '@material-ui/icons/Notifications';
import AttachFileIcon from '@material-ui/icons/AttachFile';
// Popper, not Popover.
//
// Popover renders a Modal, and Modal always lays an invisible full-screen
// Backdrop over the page (Popover passes BackdropProps={{invisible:true}},
// which only makes it transparent - it still has a click handler). So while
// the bell panel was open, the first click on the avatar landed on that
// backdrop, closed the panel, and never reached the button: everything in the
// header needed two clicks. Popper has no backdrop, no focus trap and no
// scroll lock, so the click goes where it was aimed, and ClickAwayListener
// gives back the close-on-outside-click that the backdrop was providing.
import Popper from '@material-ui/core/Popper';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import CircularProgress from '@material-ui/core/CircularProgress';
import Badge from '@material-ui/core/Badge';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import ClearIcon from '@material-ui/icons/Close';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import InputAdornment from '@material-ui/core/InputAdornment';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import { FormControl } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import Box from "@material-ui/core/Box";
import FolderSharedIcon from '@material-ui/icons/FolderShared';
import LiveHelpIcon from '@material-ui/icons/LiveHelp';
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
import SupervisedUserCircleIcon from '@material-ui/icons/SupervisedUserCircle';
import AddCircleOutlineRoundedIcon from '@material-ui/icons/AddCircleOutlineRounded';
import CategoryRoundedIcon from '@material-ui/icons/CategoryRounded';
import AssignmentRoundedIcon from '@material-ui/icons/AssignmentRounded';
import ConfirmationNumberIcon from '@material-ui/icons/ConfirmationNumber';
import RecentActorsIcon from '@material-ui/icons/RecentActors';
import FilterIcon from '@material-ui/icons/Filter';
import PhoneMissedIcon from '@material-ui/icons/PhoneMissed';
import PhoneInTalkIcon from '@material-ui/icons/PhoneInTalk';
import PhoneForwardedIcon from '@material-ui/icons/PhoneForwarded';
import AssessmentIcon from '@material-ui/icons/Assessment';
import { BsFillMicFill } from 'react-icons/bs';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import moment from 'moment';
import GroupChatWidgetIcon from './ChatWidgetIcon';
import { CALLING_DESK_PATH, CALLING_DESK_RESULTS_PATH, useCanOpenRoute } from './CallingDeskDialog';
import GroupChat from '../components/GroupChat';
import Routes from '../routes';
import HttpService from '../services/httpService';
import NotificationDetailSheet, { toneOf } from './NotificationDetailSheet';
import { getNotificationSocket, disconnectNotificationSocket } from '../notificationSocket';
import { setLoading, setSnackInfo } from '../redux/actions/appAction';
import { setUserDetails } from '../redux/actions/userAction';
import { logoutUser } from '../redux/actions/leadSourceActions';
import { connect } from 'react-redux';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';

// Import logos
import decorpotLogo from '../assets/img/org/deco_white_logo.png';
import decorpotLogoSmall from '../assets/img/org/logo-small.png';
import { ROLENAME, NarenEmail, hideSidebarInCodeLevel } from '../utils/index';
import { IoMail } from "react-icons/io5";
import { Link } from 'react-router-dom'
import { softClear, hardClear, remainingClearMs, CACHE_DIRECTIVE_POLL_MS, CACHE_CLEAR_WINDOW_MS } from '../utils/clearClientStorage';
import CacheClearAlert from './cacheClearAlert';
import { AppBar, Toolbar } from  "@material-ui/core";

const { Header, Sider, Content } = Layout;
const { SubMenu } = Menu;
const CANCEL_CHECK_EVERY_TICKS = 5;
// Jira-style filter toggle: a cross in the knob when off, a tick on green
// when on. Built with withStyles rather than props because MUI v4's Switch
// needs its track and thumb restyled together, and the checked state has to
// reach into the sibling track.
//
// Sized explicitly (44x24 with a 20px knob) - the stock `small` thumb is
// 12px, which cannot hold a legible glyph.
const IconSwitch = withStyles({
  root: { width: 44, height: 24, padding: 0, margin: '0 8px 0 0', overflow: 'visible' },
  switchBase: {
    padding: 2,
    color: '#fff',
    '&$checked': {
      transform: 'translateX(20px)',
      color: '#fff',
      '& + $track': { backgroundColor: '#1e7e34', opacity: 1 },
    },
  },
  thumb: {
    width: 20, height: 20,
    boxShadow: '0 1px 3px rgba(0,0,0,0.25)',
    display: 'grid',
    placeItems: 'center',
  },
  track: {
    borderRadius: 999,
    backgroundColor: '#c3bdb8',
    opacity: 1,
    transition: 'background-color 180ms ease',
  },
  checked: {},
})(Switch);

const useStyles = makeStyles({
  input: {
    color: "white",
    borderBottom: "1px solid #fff",
  },
  inputLabel: {
    color: "#aca9a9 !important",
  },
  icon: {
    color: 'white',
  },
  // The avatar is the whole account control: no pill, no name, no gear.
  avatarButton: {
    padding: 4,
    marginLeft: 2,
    borderRadius: '50%',
    transition: 'transform 180ms ease, box-shadow 180ms ease',
    '&:hover': {
      transform: 'translateY(-1px)',
      backgroundColor: 'transparent',
    },
    '&:hover $userAvatar': {
      boxShadow: '0 0 0 3px rgba(244, 125, 68, 0.3)',
    },
  },
  userAvatar: {
    width: 30,
    height: 30,
    borderRadius: '50%',
    display: 'grid',
    placeItems: 'center',
    flexShrink: 0,
    fontSize: 13,
    fontWeight: 700,
    // Dark glyph on the orange disc - 5.02:1, where white would be 2.6:1.
    color: '#2C2E3E',
    background: 'linear-gradient(135deg, #f47d44, #ff9c66)',
    transition: 'box-shadow 180ms ease',
  },
  // ---- shared dialog chrome (change password / logout) --------------------
  dlgPaper: { borderRadius: 18, overflow: 'hidden' },
  dlgHead: {
    display: 'flex', alignItems: 'center', gap: 14, padding: '18px 22px', color: '#fff',
    background: 'linear-gradient(135deg, #c1531f 0%, #F47E44 60%, #ff9c66 100%)',
  },
  dlgHeadDanger: {
    background: 'linear-gradient(135deg, #a3281c 0%, #c0392b 60%, #e0603f 100%)',
  },
  dlgHeadIcon: {
    width: 42, height: 42, borderRadius: 12, flexShrink: 0,
    display: 'grid', placeItems: 'center', background: 'rgba(255,255,255,0.2)',
  },
  dlgHeadText: { minWidth: 0, flex: 1 },
  dlgTitle: { fontSize: 18, fontWeight: 700, lineHeight: 1.25 },
  dlgSub: { fontSize: 12.5, color: 'rgba(255,255,255,0.88)', marginTop: 2 },
  dlgClose: {
    color: '#fff', flexShrink: 0,
    transition: 'background-color 200ms ease, transform 200ms ease',
    '&:hover': { backgroundColor: 'rgba(255,255,255,0.18)', transform: 'rotate(90deg)' },
  },
  dlgBody: { padding: '20px 22px 8px' },
  dlgActions: { padding: '12px 22px 18px', gap: 8 },
  // The three dialog buttons hold their colour on hover.
  //
  // Each &:hover repeats the resting values rather than being left out: MUI's
  // own Button styles apply a hover background of their own, so an absent rule
  // means "let MUI change it", not "do not change". Only the cursor and the
  // ripple indicate the hover now.
  btnGhost: {
    borderRadius: 22, textTransform: 'none', fontWeight: 600, padding: '6px 18px',
    color: '#c1531f', border: '1px solid rgba(244,126,68,0.5)', background: 'transparent',
    '&:hover': { background: 'transparent', color: '#c1531f', border: '1px solid rgba(244,126,68,0.5)' },
  },
  btnPrimary: {
    borderRadius: 22, textTransform: 'none', fontWeight: 700, padding: '6px 22px',
    background: '#c1531f', color: '#fff', boxShadow: 'none',
    '&:hover': { background: '#c1531f', color: '#fff', boxShadow: 'none' },
    '&.Mui-disabled': { background: '#e6e2df', color: '#9a938e' },
  },
  btnDanger: {
    borderRadius: 22, textTransform: 'none', fontWeight: 700, padding: '6px 22px',
    background: '#c0392b', color: '#fff', boxShadow: 'none',
    '&:hover': { background: '#c0392b', color: '#fff', boxShadow: 'none' },
  },

  // ---- change password ----------------------------------------------------
  strengthWrap: { marginTop: 4, marginBottom: 14 },
  strengthTop: {
    display: 'flex', justifyContent: 'space-between', alignItems: 'baseline',
    fontSize: 11.5, fontWeight: 700, letterSpacing: 0.4,
    textTransform: 'uppercase', color: '#9a938e', marginBottom: 5,
  },
  strengthTrack: { height: 6, borderRadius: 999, background: '#eeeae7', overflow: 'hidden' },
  strengthFill: { height: '100%', borderRadius: 999, transition: 'width 220ms ease, background-color 220ms ease' },
  // A grid, so the four rules do not reflow into one long column on a narrow
  // dialog and lose their pairing.
  ruleGrid: {
    display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '6px 14px',
    background: '#fbfaf9', border: '1px solid #ece8e4', borderRadius: 12,
    padding: '12px 14px', marginBottom: 6,
  },
  rule: { display: 'flex', alignItems: 'center', gap: 7, fontSize: 12.5 },
  ruleMet: { color: '#17803d', fontWeight: 600 },
  ruleUnmet: { color: '#6b6460' },
  inlineError: {
    display: 'flex', alignItems: 'center', gap: 6,
    color: '#c0392b', fontSize: 12.5, fontWeight: 600, margin: '0 0 8px',
  },
  logoutUser: {
    display: 'flex', alignItems: 'center', gap: 12,
    background: '#fbfaf9', border: '1px solid #ece8e4', borderRadius: 12,
    padding: '12px 14px', marginTop: 4,
  },
  logoutAvatar: {
    width: 38, height: 38, borderRadius: '50%', display: 'grid', placeItems: 'center',
    fontSize: 15, fontWeight: 700, color: '#2C2E3E', flexShrink: 0,
    background: 'linear-gradient(135deg, #f47d44, #ff9c66)',
  },
  logoutName: { fontWeight: 700, fontSize: 14, color: '#2f2a27' },
  logoutMail: { fontSize: 12, color: '#8a8a8a', wordBreak: 'break-all' },

  // ---- notification panel -------------------------------------------------
  userMenuPaper: { width: 250, maxWidth: '92vw', borderRadius: 14, overflow: 'hidden', marginTop: 6 },
  userMenuHead: {
    display: 'flex', alignItems: 'center', gap: 10, padding: '14px 16px',
    color: '#fff', background: 'linear-gradient(135deg, #c1531f 0%, #F47E44 60%, #ff9c66 100%)',
  },
  userMenuAvatar: {
    width: 34, height: 34, borderRadius: '50%', display: 'grid', placeItems: 'center',
    flexShrink: 0, fontSize: 14, fontWeight: 700, color: '#c1531f', background: '#fff',
  },
  userMenuName: {
    fontWeight: 700, fontSize: 13.5, lineHeight: 1.3,
    overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
  },
  userMenuMail: {
    fontSize: 11, color: 'rgba(255,255,255,0.85)', marginTop: 1,
    overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
  },
  userMenuItem: {
    fontSize: 13.5, fontWeight: 600, color: '#2f2a27', padding: '10px 16px',
    '&:hover': { background: '#fff1ea' },
  },
  userMenuDanger: {
    color: '#c0392b',
    borderTop: '1px solid #f1eeec',
    '& $menuItemIcon': { color: '#c0392b' },
    '&:hover': { background: '#fdecea' },
  },
  // Popper ships with NO z-index of its own, unlike Modal's 1300. 1250 puts
  // these panels above the app chrome and the chat widget (1000) while staying
  // below MUI's modal layer, so the notification detail dialog still opens on
  // top of the panel it was launched from.
  popperRoot: { zIndex: 1250 },
  notifPaper: { width: 380, maxWidth: '92vw', borderRadius: 14, overflow: 'hidden', marginTop: 6 },
  notifHead: {
    display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10,
    padding: '12px 16px', color: '#fff',
    background: 'linear-gradient(135deg, #c1531f 0%, #F47E44 60%, #ff9c66 100%)',
  },
  notifHeadTitle: { fontWeight: 700, fontSize: 15, display: 'flex', alignItems: 'center', gap: 8 },
  notifHeadCount: {
    fontSize: 11, fontWeight: 700, letterSpacing: 0.3,
    background: 'rgba(255,255,255,0.22)', borderRadius: 999, padding: '2px 8px',
  },
  // Holds its colour on hover - the background used to lift to 0.28, which
  // read as the button being pressed. Only the cursor marks it now.
  notifReadAll: {
    textTransform: 'none', fontWeight: 700, fontSize: 12, color: '#fff',
    background: 'rgba(255,255,255,0.18)', borderRadius: 999, padding: '2px 12px',
    minWidth: 0, boxShadow: 'none',
    '&:hover': { background: 'rgba(255,255,255,0.18)', color: '#fff', boxShadow: 'none' },
  },
  notifFilterBar: {
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    gap: 8, padding: '4px 14px 4px 10px',
    background: '#fbfaf9', borderBottom: '1px solid #f1eeec',
  },
  notifFilterLabel: { margin: 0 },
  // The knob itself. MUI paints the thumb behind this, so the white disc is
  // here rather than on `thumb`, keeping the glyph centred at any size.
  toggleKnob: {
    width: 20, height: 20, borderRadius: '50%', background: '#fff',
    display: 'grid', placeItems: 'center',
    boxShadow: '0 1px 3px rgba(0,0,0,0.25)',
  },
  notifFilterText: { fontSize: 12.5, fontWeight: 600, color: '#6b6460' },
  notifFilterCount: { fontSize: 11, fontWeight: 700, color: '#9a938e', whiteSpace: 'nowrap' },
  // The category reads before the headline does, which is the point of having
  // one - "Flow Change" tells you whether to care before you read the title.
  notifCatChip: {
    fontSize: 9.5, fontWeight: 800, letterSpacing: 0.4, textTransform: 'uppercase',
    borderRadius: 999, padding: '1px 7px', marginRight: 6, flexShrink: 0,
    whiteSpace: 'nowrap',
  },
  notifLinkIcon: { fontSize: 13, color: '#c1531f', marginLeft: 6, verticalAlign: 'middle', flexShrink: 0 },
  notifSender: {
    display: 'inline-grid', placeItems: 'center',
    width: 16, height: 16, borderRadius: '50%', marginRight: 5,
    fontSize: 9, fontWeight: 700, color: '#fff', background: '#c1531f',
    verticalAlign: 'middle',
  },
  notifList: { maxHeight: 420, overflowY: 'auto' },
  notifRow: {
    position: 'relative',
    display: 'flex', gap: 10, alignItems: 'flex-start',
    padding: '12px 16px', borderBottom: '1px solid #f1eeec', cursor: 'pointer',
    transition: 'background-color 150ms ease',
    '&:hover': { background: '#fff8f4' },
    '&:last-child': { borderBottom: 'none' },
  },
  // Unread sits on a tint AND carries a category-coloured left bar (set
  // inline, since the colour depends on the row). Read rows drop both, so the
  // two states differ in weight rather than only in hue.
  notifUnread: { background: '#fff1ea' },
  notifDot: { width: 8, height: 8, borderRadius: '50%', marginTop: 6, flexShrink: 0 },
  notifTitle: {
    fontWeight: 700, fontSize: 13.5, color: '#2f2a27', lineHeight: 1.35,
    display: 'flex', alignItems: 'center',
  },
  // Quill writes <p>/<ul>/<h*>, whose default margins would blow a three-line
  // clamp out to twice the height inside a 380px panel.
  notifBody: {
    fontSize: 12.5, color: '#6b6460', marginTop: 3, lineHeight: 1.45,
    display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical', overflow: 'hidden',
    '& p, & ul, & ol, & h1, & h2, & h3': { margin: 0 },
    '& ul, & ol': { paddingLeft: 18 },
    '& a': { color: '#c1531f' },
    '& strong': { color: '#3d2b21' },
  },
  notifMeta: { fontSize: 11, color: '#9a938e', marginTop: 4 },
  notifFiles: {
    display: 'inline-flex', alignItems: 'center', gap: 4, marginTop: 5,
    fontSize: 11, fontWeight: 700, color: '#c1531f',
    background: '#fff1ea', borderRadius: 999, padding: '2px 8px',
  },
  notifEmpty: { padding: '44px 20px', textAlign: 'center' },
  notifEmptyTitle: { fontWeight: 700, color: '#7c8695', marginTop: 10, fontSize: 13.5 },
  notifEmptyHint: { color: '#aab3bf', fontSize: 12, marginTop: 2 },

  notifBadge: {
    backgroundColor: '#ff5252',
    color: '#fff',
    fontWeight: 700,
    fontSize: 10,
    minWidth: 16,
    height: 16,
  },
  // The two bare icon buttons in the bar had no hover target at all.
  headerIconBtn: {
    color: '#f47d44',
    marginRight: 4,
    borderRadius: 10,
    transition: 'background-color 180ms ease, transform 180ms ease',
    '&:hover': {
      backgroundColor: 'rgba(244, 125, 68, 0.16)',
      transform: 'translateY(-1px)',
    },
  },
  collapseBtn: {
    color: '#fff',
    borderRadius: 10,
    transition: 'background-color 180ms ease',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.1)',
    },
  },
  menuItemIcon: {
    color: '#f47d44',
    fontSize: '19px',
    marginRight: 10,
    flexShrink: 0,
  },
  passwordNotice: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    marginRight: 16,
    paddingRight: 16,
    borderRight: '1px solid rgba(255, 255, 255, 0.12)',
  },
  passwordNoticeText: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 7,
    fontSize: 12.5,
    letterSpacing: '0.2px',
    color: 'rgba(255, 255, 255, 0.68)',
    whiteSpace: 'nowrap',
    lineHeight: 1,
  },
  noticeIcon: {
    fontSize: 16,
    color: 'rgba(255, 255, 255, 0.5)',
  },
  daysBadge: {
    fontFamily: "'Silka bold', 'Silka semiBold', sans-serif !important",
    fontWeight: '700 !important',
    fontSize: 12.5,
    // #f47d44 on its own tinted pill is 4.07:1; the lighter tone clears AA.
    color: '#ff9c66',
    backgroundColor: 'rgba(244, 125, 68, 0.14)',
    border: '1px solid rgba(244, 125, 68, 0.35)',
    borderRadius: 999,
    padding: '2px 9px',
    lineHeight: 1.4,
  },
  // A password expiring in 3 days and one expiring in 60 looked identical.
  // Under a week it turns red, so the countdown is worth glancing at.
  daysBadgeUrgent: {
    color: '#ff8a80',
    backgroundColor: 'rgba(255, 82, 82, 0.16)',
    border: '1px solid rgba(255, 82, 82, 0.45)',
  },
  changePasswordButton: {
    "&.ant-btn": {
      display: 'inline-flex',
      alignItems: 'center',
      margin: 0,
      padding: '0 14px',
      height: 28,
      width: 'auto',
      minWidth: 0,
      borderRadius: 999,
      backgroundColor: 'transparent',
      color: '#f47d44',
      border: '1px solid rgba(244, 125, 68, 0.55)',
      fontFamily: "'Silka bold', 'Silka semiBold', sans-serif !important",
      fontWeight: '700 !important',
      fontSize: 11,
      letterSpacing: '0.3px',
      textTransform: 'none',
      whiteSpace: 'nowrap',
      boxShadow: 'none',
      transition: 'background-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease',
    },
    "&.ant-btn:hover, &.ant-btn:focus": {
      backgroundColor: '#f47d44',
      color: '#ffffff',
      borderColor: '#f47d44',
      boxShadow: '0 4px 12px rgba(244, 125, 68, 0.30)',
    },
  },
  routeContentWrapper: {
    opacity: 1,
    transition: 'opacity 0.3s ease-in-out',
  },
  fadeExit: {
    opacity: 0,
  },
  fadeEnterActive: {
    opacity: 1,
  },
  profileDialogPaper: {
    borderRadius: 20,
    overflow: 'hidden',
    boxShadow: '0 22px 60px rgba(193, 83, 31, 0.28)',
  },
  '@keyframes profileCardIn': {
    from: { opacity: 0, transform: 'translateY(8px)' },
    to: { opacity: 1, transform: 'translateY(0)' },
  },
  '@keyframes profileAvatarIn': {
    from: { opacity: 0, transform: 'scale(0.7)' },
    to: { opacity: 1, transform: 'scale(1)' },
  },
  profileHeader: {
    position: 'relative',
    overflow: 'hidden',
    padding: '30px 28px 24px',
    background: 'linear-gradient(135deg, #c1531f 0%, #f47e46 60%, #ff9c66 100%)',
    display: 'flex',
    alignItems: 'center',
    gap: 18,
    '&::before': {
      content: '""',
      position: 'absolute',
      top: -46,
      right: -30,
      width: 150,
      height: 150,
      borderRadius: '50%',
      backgroundColor: 'rgba(255, 255, 255, 0.09)',
      pointerEvents: 'none',
    },
    '&::after': {
      content: '""',
      position: 'absolute',
      bottom: -55,
      right: 60,
      width: 110,
      height: 110,
      borderRadius: '50%',
      backgroundColor: 'rgba(255, 255, 255, 0.07)',
      pointerEvents: 'none',
    },
  },
  profileHeaderClose: {
    position: 'absolute',
    top: 10,
    right: 10,
    padding: 6,
    color: '#fff',
    backgroundColor: 'rgba(255, 255, 255, 0.16)',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.28)',
    },
  },
  profileAvatar: {
    position: 'relative',
    zIndex: 1,
    width: 66,
    height: 66,
    borderRadius: '50%',
    backgroundColor: 'rgba(255, 255, 255, 0.22)',
    border: '2px solid rgba(255, 255, 255, 0.65)',
    boxShadow: '0 0 0 4px rgba(255, 255, 255, 0.12)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 24,
    fontWeight: 700,
    color: '#ffffff',
    fontFamily: "'Silka bold', 'Silka semiBold', sans-serif",
    flexShrink: 0,
    animation: '$profileAvatarIn 0.4s cubic-bezier(0.34, 1.56, 0.64, 1) both',
  },
  profileHeaderText: {
    position: 'relative',
    zIndex: 1,
    minWidth: 0,
  },
  profileHeaderName: {
    fontSize: 19,
    fontWeight: 700,
    color: '#ffffff',
    fontFamily: "'Silka bold', 'Silka semiBold', sans-serif",
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  profileHeaderRoleList: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 6,
    marginTop: 8,
  },
  profileHeaderRole: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '3px 11px',
    borderRadius: 999,
    fontSize: 11.5,
    fontWeight: 700,
    letterSpacing: '0.3px',
    color: '#ffffff',
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    border: '1px solid rgba(255, 255, 255, 0.35)',
    whiteSpace: 'nowrap',
  },
  profileBody: {
    padding: '22px 26px 6px',
    backgroundColor: '#fafafa',
    maxHeight: 'calc(100vh - 280px)',
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
      width: 6,
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(244, 126, 68, 0.35)',
      borderRadius: 10,
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: 'transparent',
    },
  },
  profileSection: {
    marginBottom: 20,
    '&:last-child': {
      marginBottom: 6,
    },
  },
  profileSectionTitle: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    fontSize: 11.5,
    fontWeight: 700,
    letterSpacing: '0.4px',
    textTransform: 'uppercase',
    color: '#c1531f',
    marginBottom: 10,
    '&::after': {
      content: '""',
      flex: 1,
      height: 1,
      backgroundColor: '#f0ddce',
    },
  },
  profileGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: 14,
    '& > div:nth-child(1)': { animationDelay: '0.02s' },
    '& > div:nth-child(2)': { animationDelay: '0.07s' },
    '& > div:nth-child(3)': { animationDelay: '0.12s' },
    '& > div:nth-child(4)': { animationDelay: '0.17s' },
  },
  profileCard: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 12,
    padding: '14px 16px',
    borderRadius: 14,
    backgroundColor: '#ffffff',
    border: '1px solid #f2e6da',
    transition: 'box-shadow 0.2s ease, transform 0.2s ease, border-color 0.2s ease',
    minWidth: 0,
    opacity: 0,
    animation: '$profileCardIn 0.35s ease both',
    '&:hover': {
      boxShadow: '0 6px 16px rgba(244, 126, 68, 0.16)',
      borderColor: 'rgba(244, 126, 68, 0.35)',
      transform: 'translateY(-1px)',
    },
  },
  profileCardFull: {
    gridColumn: '1 / -1',
  },
  profileCardTop: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 8,
  },
  profileCopyBtn: {
    padding: 5,
    color: '#c1531f',
    flexShrink: 0,
    '&:hover': {
      backgroundColor: 'rgba(244, 126, 68, 0.12)',
    },
  },
  profileChipList: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 6,
    marginTop: 3,
  },
  profileChip: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '3px 11px',
    borderRadius: 999,
    fontSize: 12.5,
    fontWeight: 600,
    color: '#c1531f',
    backgroundColor: 'rgba(244, 126, 68, 0.1)',
    border: '1px solid rgba(244, 126, 68, 0.22)',
  },
  profileCardIcon: {
    width: 38,
    height: 38,
    borderRadius: 11,
    background: 'linear-gradient(135deg, rgba(244, 126, 68, 0.22), rgba(244, 126, 68, 0.08))',
    color: '#e06a34',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 17,
    flexShrink: 0,
  },
  profileCardLabel: {
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: '0.3px',
    textTransform: 'uppercase',
    color: '#9a9a9a',
    marginBottom: 2,
  },
  profileCardValue: {
    fontSize: 14,
    fontWeight: 600,
    color: '#2b2b2b',
    wordBreak: 'break-word',
  },
  profileCloseButton: {
    '&.ant-btn': {
      borderRadius: 999,
      fontWeight: 700,
      height: 36,
      padding: '0 26px',
      backgroundColor: '#f47e46',
      borderColor: '#f47e46',
      color: '#ffffff',
      boxShadow: 'none',
    },
    '&.ant-btn:hover, &.ant-btn:focus': {
      backgroundColor: '#e06a34',
      borderColor: '#e06a34',
      color: '#ffffff',
    },
  },
});

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

// Calling Desk dropdown - each child shows only with Route Access to its page.
const CALLING_DESK_MENU_KEY = 'calling-desk-menu';
const CALLING_DESK_CHILDREN = [
  { key: 'calling-desk', label: 'Calls', Icon: 'PhoneForwardedIcon', url: CALLING_DESK_PATH, isActive: true, priority: 1, subMenu: [] },
  { key: 'calling-desk-results', label: 'Results', Icon: 'AssessmentIcon', url: CALLING_DESK_RESULTS_PATH, isActive: true, priority: 2, subMenu: [] },
];

const Sidebar = React.memo((props) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const dispatch = useDispatch();
  const open = Boolean(anchorEl);
  const classes = useStyles();
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const { userDetails } = useSelector(state => state.user);
  const userRoles = Array.isArray(userDetails?.roles) ? userDetails.roles : [];
  const [sidebarItems, setSidebarItems] = useState([]);
  const [changePasswordModal, setChangePasswordModal] = useState(false);
  const [expcenters, setExpcenters] = useState([]);
  const [locations, setLocations] = useState([]);
  const [defaultLocation, setDefaultLocation] = useState(userDetails?.selectedLocation);
  const [defaultExpCenter, setDefaultExpCenter] = useState(userDetails?.selectedExpCenter);
  const [password, setPassword] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: ""
  });

  const [showPassword, setShowPassword] = useState(false);
  const [isPasswordShort, setIsPasswordShort] = useState(false);
  const [showChatComponent, setShowChatComponent] = useState(false);
  const [isConfirmPasswordMatched, setIsConfirmPasswordMatched] = useState(true);
  const [isPasswordValidated, setIsPasswordValidated] = useState({
    hasNumber: false,
    hasUpperCase: false,
    hasLowerCase: false,
    hasSpecialChar: false
  });
  const [passwordStrength, setPasswordStrength] = useState("");
  const [passwordStrengthColor, setPasswordStrengthColor] = useState("red");
  const [daysRemainingToChangePassword, setDaysRemainingToChangePassword] = useState(90 - (userDetails?.DaysRemainingToChangePassword || 0));
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [openKeys, setOpenKeys] = useState([]);
  const [selectedKeys, setSelectedKeys] = useState(['dashboard']);
  const [profileModal, setProfileModal] = useState(false);
  const [experienceCenter, setSexperienceCenterId] = useState([]);
  const [logoutConfirmModal, setLogoutConfirmModal] = useState(false);
  const [assistantManager, setAssistantManager] = useState("");
  // Pending admin-triggered cache/session clear for this browser, and the warning countdown.
  // The ref guards the poll so a directive already being counted down is not picked up twice.
  const [cacheDirective, setCacheDirective] = useState(null);
  const [cacheClearRemainingMs, setCacheClearCountdown] = useState(0);
  const cacheDirectiveHandled = useRef(false);
  const [departmentName, setDepartmentName] = useState('');
  const history = useHistory();
  const location = useLocation();
  const hideScanBarcode = hideSidebarInCodeLevel.includes(userDetails?.email);

  const copyProfileValue = (value, label) => {
    if (!value) return;
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(value)
        .then(() => props.setSnackInfo(`${label} copied to clipboard`, "success"))
        .catch(() => props.setSnackInfo(`Could not copy ${label}`, "error"));
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      if (window.innerWidth > 768) {
        setMobileOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);

    getAsideItems();
    getLocationList();
    expireSession();
    fetchUserData();
    getDepartments();
    return () => {
      window.removeEventListener('resize', handleResize);
    };
    // eslint-disable-next-line
  }, []);

  // Set initially selected key based on current path
  useEffect(() => {
    updateSelectedKeysFromPath(location.pathname);
  }, [location.pathname, sidebarItems]);

  const getDepartments = async () => {
    try {
      const response = await HttpService.getDepartments();
      const departments = response?.data || [];
      const targetId = userDetails?.departmentId;
      const targetDepartment = departments.find(dep => dep._id === targetId);

      if (targetDepartment) {
        setDepartmentName(targetDepartment.name);
      } else {
        console.log("Department not found with ID:", targetId);
      }
    } catch (error) {
      console.error("Error fetching departments:", error);
    }
  };

  // Function to update selected keys based on current path
  const updateSelectedKeysFromPath = (pathname) => {
    // Calling Desk is added in code (withCallingDeskMenu), not part of sidebarItems.
    const callingDeskChild = CALLING_DESK_CHILDREN.find(child => child.url === pathname);
    if (callingDeskChild) {
      setSelectedKeys([callingDeskChild.key]);
      setOpenKeys(prevOpenKeys => (prevOpenKeys.includes(CALLING_DESK_MENU_KEY) ? prevOpenKeys : [...prevOpenKeys, CALLING_DESK_MENU_KEY]));
      return;
    }

    let foundKey = null;
    let parentKey = null;

    const findMenuItemByUrl = (items, parent = null) => {
      for (const item of items) {
        if (item.url && pathname === item.url) {
          foundKey = item.key;
          parentKey = parent;
          return true;
        }

        if (item.url && pathname.startsWith(item.url)) {
          foundKey = item.key;
          parentKey = parent;
        }

        if (item.subMenu && item.subMenu.length > 0) {
          const found = findMenuItemByUrl(item.subMenu, item.key);
          if (found) return true;
        }
      }
      return false;
    };

    if (sidebarItems.length > 0) {
      findMenuItemByUrl(sidebarItems);
    }

    if (foundKey) {
      setSelectedKeys([foundKey]);
      if (parentKey) {
        setOpenKeys(prevOpenKeys => {
          if (!prevOpenKeys.includes(parentKey)) {
            return [...prevOpenKeys, parentKey];
          }
          return prevOpenKeys;
        });
      }
    }
  };

  const fetchUserData = async () => {
    try {
        const response = await HttpService.getUserById(userDetails._id);
        
      // if (response.data.cacheClearRequired && localStorage.length > 0) {
      //     const updateUserCache = await HttpService.updateUserCacheById(userDetails._id);
      //   if (updateUserCache.data === 'ok') {
      //     localStorage.clear();
      //   }
      // }

      let MyLastPasswordCreationDate = new Date(response.data.LastPasswordCreationDate);
      let CurrentDate = new Date();
        let timeDifference = CurrentDate.getTime() - MyLastPasswordCreationDate.getTime();
      let DaysRemainingToChangePassword = 90 - (Math.floor(timeDifference / (1000 * 60 * 60 * 24)));

      setDaysRemainingToChangePassword(DaysRemainingToChangePassword);
      setSexperienceCenterId(response.data?.experienceCenterId);
      setAssistantManager(response.data?.assistantManagerId?.name);
      if (DaysRemainingToChangePassword < 1) {
        localStorage.clear();
        history.push('/');
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };


  // Admin-triggered "Cache & Session Management" clears. An admin can target this browser
  // individually, by role, by department, or as part of an all-users clear; whichever it is, it
  // arrives here as a pending directive. 'soft' keeps the user signed in, 'hard' signs them out.

  // useEffect(() => {
  //   if (!userDetails?._id) return;

  //   const checkCacheDirective = async () => {
  //     if (cacheDirectiveHandled.current) return;
  //     try {
  //       const { data } = await HttpService.getPendingCacheDirective();
  //       if (!data?.pending) return;

  //       cacheDirectiveHandled.current = true;
  //       setCacheDirective(data);
  //     } catch (error) {
  //       console.error('Error checking cache directive:', error);
  //     }
  //   };

  //   checkCacheDirective();
  //   const directiveIntervalId = setInterval(checkCacheDirective, CACHE_DIRECTIVE_POLL_MS);
  //   return () => clearInterval(directiveIntervalId);
  // }, [userDetails?._id])

  // Counts down to the instant the clear is due — requestedAt (a server timestamp) plus the window
  // — rather than counting down from whenever this browser happened to notice. That is what makes
  // this timer and the admin's timer show the same number.
  // useEffect(() => {
  //   if (!cacheDirective) return undefined;

  //   let applied = false;
  //   let tickId = null;
  //   let ticks = 0;

  //   const dismiss = () => {
  //     if (applied) return;
  //     if (tickId) clearInterval(tickId);
  //     cacheDirectiveHandled.current = false;
  //     setCacheDirective(null);
  //   };

  //   const applyClear = async () => {
  //     if (applied) return;
  //     applied = true;
  //     try {
  //       const { data } = await HttpService.getPendingCacheDirective();
  //       if (!data?.pending) {
  //         // Cancelled in the last moment before the wipe.
  //         cacheDirectiveHandled.current = false;
  //         setCacheDirective(null);
  //         return;
  //       }

  //       await HttpService.ackCacheDirective(data.requestId, data.legacy);

  //       if (data.mode === 'hard') {
  //         await hardClear({ dispatch, logoutUser, setUserDetails: props.setUserDetails });
  //       } else {
  //         await softClear({ setUserDetails: props.setUserDetails });
  //       }
  //     } catch (error) {
  //       console.error('Error applying cache directive:', error);
  //       cacheDirectiveHandled.current = false;
  //       setCacheDirective(null);
  //     }
  //   };

  //   const checkStillPending = async () => {
  //     if (applied) return;
  //     try {
  //       const { data } = await HttpService.getPendingCacheDirective();
  //       if (!data?.pending) dismiss();
  //     } catch (error) {
  //       // A network blip is not a cancellation — leave the warning up and try again next time.
  //       console.error('Error re-checking cache directive:', error);
  //     }
  //   };

  //   const tick = () => {
  //     // The legacy cacheClearRequired flag carries no timestamp, so give it a full window.
  //     const remaining = cacheDirective.requestedAt
  //       ? remainingClearMs(cacheDirective.requestedAt)
  //       : CACHE_CLEAR_WINDOW_MS;

  //     setCacheClearCountdown(Math.max(0, remaining));

  //     if (remaining <= 0) {
  //       if (tickId) clearInterval(tickId);
  //       applyClear();
  //       return;
  //     }

  //     ticks += 1;
  //     if (ticks % CANCEL_CHECK_EVERY_TICKS === 0) checkStillPending();
  //   };

  //   tick();
  //   if (!applied) tickId = setInterval(tick, 1000);

  //   return () => { if (tickId) clearInterval(tickId); };
  // }, [cacheDirective])
  
  const expireSession = () => {
    let version = "2.7";
    if (!localStorage.getItem('VERSION_KEY')) {
      localStorage.setItem('VERSION_KEY', version);
    } else if (localStorage.getItem('VERSION_KEY') !== version) {
      localStorage.removeItem('TOKEN_KEY');
      window.location.reload();
      localStorage.setItem('VERSION_KEY', version);
    } else if (localStorage.getItem('VERSION_KEY') === version) {
      localStorage.setItem('VERSION_KEY', version);
    }
  };

  const getAsideItems = async () => {
    props.setLoading(true);
    try {
      const response = await HttpService.getAsideItems();
      setSidebarItems(response.data);
      updateSelectedKeysFromPath(location.pathname);
    } catch (error) {
      console.error(error);
      props.setSnackInfo(error?.response?.data?.message ?? "Something Went Wrong", "error");
      if (error?.response?.data?.success === false) {
        localStorage.clear();
        props.setUserDetails({});
        history.push('/');
      }
    }
    props.setLoading(false);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const toggleDrawer = () => {
    setMobileOpen(!mobileOpen);
  };

  const toggleCollapse = () => {
    setCollapsed(!collapsed);
  };

  const logout = async () => {
    handleClose();
    setLogoutConfirmModal(false);
    // localStorage.clear();
    // let reload = userDetails.roles.find(role => role.name === 'TeleCaller' || role.name === 'TeleCallerAssistantManager');
    // dispatch(logoutUser());
    // props.setUserDetails({});
    // history.push('/');
    // reload && window.location.reload();
    // hardClear also empties sessionStorage, cookies and the redux-persist blob in IndexedDB,
    // which a bare localStorage.clear() left behind, and ends with a full navigation to '/'.
    await hardClear({ dispatch, logoutUser, setUserDetails: props.setUserDetails });
  };

  // Handle submenu open/close
  const handleOpenChange = (keys) => {
    setOpenKeys(keys);
  };

  // Handle menu item selection
  const handleMenuClick = (e) => {
    setSelectedKeys([e.key]);
  };

  // ---- notifications ------------------------------------------------------
  const [notifAnchor, setNotifAnchor] = useState(null);
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [notifLoading, setNotifLoading] = useState(false);
  const [onlyUnread, setOnlyUnread] = useState(false);
  // The row being read in full. Holds the row object itself rather than an id,
  // so the dialog keeps rendering through the refetch a socket push triggers -
  // looking an id up in a list that is being replaced underneath would blank
  // the dialog mid-read.
  const [detailNotif, setDetailNotif] = useState(null);

  // Filtered from what is already loaded - no request when the toggle flips.
  // Kept as a separate list rather than filtering in place, so the header can
  // still say "3 of 20" and the empty state can tell the two cases apart.
  const visibleNotifications = onlyUnread
    ? notifications.filter((n) => !n.readAt)
    : notifications;

  const loadNotifications = useCallback(async () => {
    setNotifLoading(true);
    try {
      const res = await HttpService.getMyNotifications(20);
      setNotifications(res.data.notifications || []);
      setUnreadCount(res.data.unreadCount || 0);
    } catch (err) {
      // The bell is ambient. A failed poll should never put an error toast in
      // front of whatever the person is actually doing.
      console.error('Could not load notifications:', err);
    }
    setNotifLoading(false);
  }, []);

  // Pushed, not polled.
  //
  // This used to be a 60s setInterval, which cost 60 requests an hour per open
  // tab whether or not anything had been sent - and still took up to a minute
  // to show an announcement. inventoryapi now emits to a per-user room, so the
  // bell updates the moment Send is pressed.
  //
  // Three fetches remain, and none of them is a timer:
  //   - on connect, which also covers every reconnect, so anything sent while
  //     the socket was down is picked up as soon as it is back;
  //   - when the tab regains focus, for the case where the socket died without
  //     the browser noticing (laptop sleep is the usual one);
  //   - when the bell is opened.
  //
  // Depends on the id, NOT the whole userDetails object: the reducer returns a
  // fresh object on every SET_USER_DETAILS and that is dispatched from several
  // unrelated places, which would otherwise tear the socket down and rebuild
  // it on each one.
  const userId = userDetails?._id;
  useEffect(() => {
    if (!userId) return undefined;

    const socket = getNotificationSocket();

    const onConnect = () => loadNotifications();
    // The payload is enough to bump the badge immediately; /mine stays the
    // source of truth, so the row itself comes from the refetch.
    const onNew = () => loadNotifications();
    const onFocus = () => loadNotifications();

    socket.on('connect', onConnect);
    socket.on('notification:new', onNew);
    socket.on('connect_error', (err) => console.error('Notification socket:', err.message));
    window.addEventListener('focus', onFocus);

    if (!socket.connected) socket.connect();
    loadNotifications();

    return () => {
      socket.off('connect', onConnect);
      socket.off('notification:new', onNew);
      socket.off('connect_error');
      window.removeEventListener('focus', onFocus);
    };
  }, [userId, loadNotifications]);

  // Dropped on sign-out, so the next person to sign in on a shared machine
  // does not inherit a socket authenticated as the previous one.
  useEffect(() => {
    if (!userId) disconnectNotificationSocket();
  }, [userId]);

  // Modal gave Escape-to-close for free; Popper does not, so it is wired here
  // rather than quietly lost in the swap. Bound only while something is open.
  useEffect(() => {
    if (!notifAnchor && !anchorEl) return undefined;
    const onKeyDown = (e) => {
      if (e.key !== 'Escape') return;
      // The detail dialog is on top and closes itself on Escape - this must
      // not pull the panel out from under it on the same keypress.
      if (detailNotif) return;
      setNotifAnchor(null);
      setAnchorEl(null);
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [notifAnchor, anchorEl, detailNotif]);

  const markAllRead = async () => {
    try {
      await HttpService.markAllNotificationsRead();
      setNotifications((prev) => prev.map((n) => ({ ...n, readAt: n.readAt || new Date().toISOString() })));
      setUnreadCount(0);
    } catch (err) {
      console.error('Could not mark notifications read:', err);
    }
  };

  // A click opens the full message rather than navigating.
  //
  // It used to jump straight to n.link, which skipped the message entirely -
  // the body, who sent it and any attachments were only ever visible as the
  // three-line clamp in the panel. The link is now a button inside the dialog,
  // so reading and going there are two separate decisions.
  const openNotification = async (n) => {
    setDetailNotif(n);

    // Marked read optimistically - waiting on the round trip before the dot
    // clears makes the click feel broken.
    if (!n.readAt) {
      setNotifications((prev) => prev.map((row) => (row._id === n._id ? { ...row, readAt: new Date().toISOString() } : row)));
      setUnreadCount((prev) => Math.max(0, prev - 1));
      try {
        await HttpService.markNotificationRead(n._id);
      } catch (err) {
        console.error('Could not mark notification read:', err);
      }
    }
  };

  // Reveal toggles. Typing a password you cannot see, three times, is where
  // "passwords do not match" usually comes from.
  const [showPw, setShowPw] = useState({ current: false, next: false, confirm: false });
  const pwToggle = (key) => (
    <InputAdornment position="end">
      <IconButton
        size="small"
        tabIndex={-1}
        aria-label={showPw[key] ? 'Hide password' : 'Show password'}
        onClick={() => setShowPw((prev) => ({ ...prev, [key]: !prev[key] }))}
      >
        {showPw[key] ? <VisibilityOffIcon style={{ fontSize: 18 }} /> : <VisibilityIcon style={{ fontSize: 18 }} />}
      </IconButton>
    </InputAdornment>
  );

  // Maps the five strength words onto a bar. Colours come from here rather
  // than passwordStrengthColor because 'lightgreen' on white is ~1.4:1 and
  // was unreadable for the two levels that still block submission.
  const STRENGTH_METER = {
    'Very Weak': { pct: 20, color: '#c0392b' },
    'Weak': { pct: 40, color: '#c04a00' },
    'Ok': { pct: 60, color: '#9c5d00' },
    'Strong': { pct: 80, color: '#17803d' },
    'Very Strong': { pct: 100, color: '#0f5c2a' },
  };
  const strengthMeter = STRENGTH_METER[passwordStrength] || { pct: 0, color: '#c3bdb8' };

  const checkPasswordStrength = (password) => {
    const strengthLevels = {
      veryWeak: /^(?=.*[a-z])/,
      weak: /^(?=.*[a-z])(?=.*[A-Z])/,
      ok: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/,
      strong: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])/,
      veryStrong: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])(?=.{8,})/,
    };
  
    if (strengthLevels.veryStrong.test(password)) {
      setPasswordStrengthColor('darkgreen');
      return 'Very Strong';
    } else if (strengthLevels.strong.test(password)) {
      setPasswordStrengthColor('lightgreen');
      return 'Strong';
    } else if (strengthLevels.ok.test(password)) {
      setPasswordStrengthColor('blue');
      return 'Ok';
    } else if (strengthLevels.weak.test(password)) {
      setPasswordStrengthColor('orange');
      return 'Weak';
    } else {
      setPasswordStrengthColor('red');
      return 'Very Weak';
    }
  };

  const changePassword = async () => {
    props.setLoading(true);

    const isPasswordValid = validatePassword(password.newPassword);

    if (!isPasswordValid) {
      props.setSnackInfo('Password should contain atleast one Uppercase, Lowercase, Numeric & Special character !,@,#,$,~,`,_,-,*,&,^,%', "error");
      props.setLoading(false);
      return null;
    }
    
    try {
      if (password.newPassword !== password.confirmPassword)
        return props.setSnackInfo('Passwords Do Not Match', "error");

      let response = await HttpService.changePassword({ password: password.currentPassword, newPassword: password.newPassword });
      props.setSnackInfo(response?.data?.message, "success");

        setPassword({
        currentPassword: "",
        newPassword: "",
        confirmPassword: ""
      });

      setChangePasswordModal(false);
      localStorage.clear();
      history.push('/');

    } catch (error) {
      console.error(error);
      props.setSnackInfo(error?.response?.data?.message ?? "Something went Wrong", "error");
    }
    props.setLoading(false);
  };

  const validatePassword = (password) => {
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$~`_\-*&^%])[A-Za-z\d!@#$~`_\-*&^%]{8,}$/;
    return regex.test(password);
  };
  
  const validatePassword2 = (password) => {
    const numberRegex = /\d/;
    const upperCaseRegex = /[A-Z]/;
    const lowerCaseRegex = /[a-z]/;
    const specialCharRegex = /[!@#$~`_\-*&^%]/;

    const hasNumber = numberRegex.test(password);
    const hasUpperCase = upperCaseRegex.test(password);
    const hasLowerCase = lowerCaseRegex.test(password);
    const hasSpecialChar = specialCharRegex.test(password);

    return {
        hasNumber,
        hasUpperCase,
        hasLowerCase,
        hasSpecialChar
    };
  };

  const changeHandler = (e) => {
    let name = e.target.name;
    let value = e.target.value;

    if (name === 'newPassword') {
      const passwordStrength = checkPasswordStrength(value);
      setPasswordStrength(passwordStrength);
      const passwordValidation = validatePassword2(value);
      setIsPasswordValidated(passwordValidation);

      if (value.length < 8) {
        setIsPasswordShort(true);
      } else {
        setIsPasswordShort(false);
      }

      if (value !== password.confirmPassword) {
        setIsConfirmPasswordMatched(false);
      } else {
        setIsConfirmPasswordMatched(true);
      }
    } else if (name === 'confirmPassword') {
      if (password.newPassword !== value) {
        setIsConfirmPasswordMatched(false);
      } else {
        setIsConfirmPasswordMatched(true);
      }
    }
    setPassword({ ...password, [e.target.name]: value });
  };
  
  const handleCancelForChangePassword = () => {
    setIsPasswordShort(false);
    setIsConfirmPasswordMatched(true);
    setPassword({
      ...password,
      currentPassword: "",
      newPassword: "",
      confirmPassword: ""
    });
    setChangePasswordModal(false);
  };

  const getLocationList = async () => {
    try {
      const response = await HttpService.getLocationList();
      let userLocation = [];
      for (let i = 0; i < response.data.length; i++) {
        for (let j = 0; j < userDetails.locationId.length; j++) {
          if (response.data[i]._id === userDetails.locationId[j]._id) {
            userLocation.push({
              _id: userDetails.locationId[j]._id,
              name: userDetails.locationId[j].name
            });
          }
        }
      }
      setLocations(userLocation);
      setDefaultLocation(userDetails.selectedLocation);
      getExperienceCenterByLocation(userDetails.selectedLocation);
    } catch (error) {
      console.log(error);
    }
  };

  const getExpCenterByCity = async (cityid) => {
    setDefaultLocation(cityid);
    await getExperienceCenterByLocation(cityid);
  };

  const getExperienceCenterByLocation = async (locid) => {
    try {
      const response = await HttpService.getExpericenCentersByLocation(locid);
      let userExpCenters = [];
      for (let i = 0; i < response.data.length; i++) {
        for (let j = 0; j < userDetails.experienceCenterId.length; j++) {
          if (userDetails.experienceCenterId[j] === response.data[i]['_id']) {
            userExpCenters.push({
              name: response.data[i]['name'],
              _id: response.data[i]['_id']
            });
          }
        }
      }
      setExpcenters(userExpCenters);
    } catch (error) {
      console.log(error);
    }
  };
 
  const handleexpcenter = (e) => {
    setDefaultExpCenter(e.target.value);
    props.setUserDetails({
      ...userDetails,
      selectedExpCenter: e.target.value,
      selectedLocation: defaultLocation
    });
    setTimeout(() => {
      window.location.reload(false);
    }, 1000);
  };

  const handleChatIconClick = () => {
    setShowChatComponent(!showChatComponent);
  };

  const handleCloseChat = () => {
      setShowChatComponent(false);
  };

  const iconComponents = {
    "DashboardOutlined": DashboardOutlined,
    'SettingOutlined': SettingOutlined,
    'ControlOutlined': ControlOutlined,
    'EqualizerIcon': EqualizerIcon,
    'CalendarOutlined': CalendarOutlined,
    'UserOutlined': UserOutlined,
    'AssignmentRoundedIcon': AssignmentRoundedIcon,
    'CategoryRoundedIcon': CategoryRoundedIcon,
    'CalculatorOutlined': CalculatorOutlined,
    'ReadOutlined': ReadOutlined,
    'BarsOutlined': BarsOutlined,
    'ReconciliationOutlined': ReconciliationOutlined,
    'DiffOutlined': DiffOutlined,
    'ShopOutlined': ShopOutlined,
    'ShoppingCartOutlined': ShoppingCartOutlined,
    'GiftOutlined': GiftOutlined,
    'RocketOutlined': RocketOutlined,
    'HomeOutlined': HomeOutlined,
    'FileDoneOutlined': FileDoneOutlined,
    "SupervisedUserCircleIcon": SupervisedUserCircleIcon,
    "FolderSharedIcon": FolderSharedIcon,
    "LocalLibraryIcon": LocalLibraryIcon,
    "LiveHelpIcon": LiveHelpIcon,
    "AddShoppingCartIcon": AddShoppingCartIcon,
    "CloudDownloadIcon": CloudDownloadIcon,
    "BallotIcon": BallotIcon,
    "CarryOutOutlined": CarryOutOutlined,
    "SignalFilled": SignalFilled,
    "UploadOutlined": UploadOutlined,
    'AuditOutlined': AuditOutlined,
    'PhoneOutlined': PhoneOutlined,
    'PhoneInTalkIcon': PhoneInTalkIcon,
    'PhoneForwardedIcon': PhoneForwardedIcon,
    'AssessmentIcon': AssessmentIcon,
    'ConfirmationNumber': ConfirmationNumberIcon,
    'RecentActorsIcon': RecentActorsIcon,
    'FilterIcon': FilterIcon,
    'CustomerServiceOutlined': CustomerServiceOutlined,
    'BsFillMicFill': BsFillMicFill,
    'MonetizationOnIcon': MonetizationOnIcon,
    'WhatsAppOutlined': WhatsAppOutlined,
    'PhoneMissedIcon': PhoneMissedIcon,
    'FileSyncOutlined': FileSyncOutlined,
    // Payment QR Code (/payment-qr-code)
    'QrcodeOutlined': QrcodeOutlined,
    // Cron Job Monitor (/cron-job-monitor)
    'FieldTimeOutlined': FieldTimeOutlined,
    // Send Notification (/send-notification)
    'NotificationOutlined': NotificationOutlined,
    // My Notifications (/my-notifications)
    'BellOutlined': BellOutlined
  };

const replaceDatePlaceholders = (url) => {
  const datePattern = /\$\{moment\(\).subtract\((\d+), 'months'\).format\('YYYY-MM-DD'\)\}\/\$\{moment\(\).add\((\d+), 'days'\).format\('YYYY-MM-DD'\)\}/;

  return url.replace(datePattern, (match, subtractMonths, addDays) => {
      const startDate = moment().subtract(parseInt(subtractMonths), 'months').format('YYYY-MM-DD');
      const endDate = moment().add(parseInt(addDays), 'days').format('YYYY-MM-DD');
      return `${startDate}/${endDate}`;
    });
  };

  // sales user disable sidebar / navigation
  const isRoleSE = userRoles.some((role) => role?.name === 'Sales User');
  const isRoleASM = userRoles.some((role) => role?.name === 'Assistant Sales Manager');
  const isRoleODM = userRoles.some((role) => role?.name === 'Operation Design Manager');
  const isRoleAGMDesign = userRoles.some((role) => role?.name === 'AGM Design');
  const isRoleOdmOrAgm = isRoleODM || isRoleAGMDesign;

  const salesUserDashboardDisable = () => {
    let localData = JSON.parse(localStorage.getItem('disableMenu')) || {};

    if (typeof localData !== 'object' || localData === null) {
      localData = {};
    }
    const isDisabled = Object.values(localData).some(value => value > 0);
    return isRoleSE && isDisabled;
  };

  const asmDashboardDisable = () => {
    const raw = localStorage.getItem('dashboardFrozen');
    const isFrozen = raw === 'true';
    return isRoleASM && isFrozen;
  };

  const odmAgmDashboardDisable = () => {
    const raw = localStorage.getItem('dashboardFrozen');
    const isFrozen = raw === 'true';
    return isRoleOdmOrAgm && isFrozen;
  };

  const renderMenuItems = (menuItems, parentUrl = '') => {
    const menuRoleSE = userRoles.some((role) => role?.name === 'Sales User');
    const localData = JSON.parse(localStorage.getItem('disableMenu')) || {};

    if (typeof localData !== 'object' || localData === null) {
      localData = {}; 
    }
    const isDisabled = Object.values(localData).some(value => value > 0);
    const disabled = menuRoleSE && isDisabled;

    menuItems.sort((a, b) => a.priority - b.priority);
  
    return menuItems.map(menuItem => {
      if (menuItem.isActive) {
        let url = menuItem.url;
        url = replaceDatePlaceholders(url);
        const IconComponent = iconComponents[menuItem.Icon]; 
  
        if (menuItem.subMenu && menuItem.subMenu.length > 0) {
          return (
            <SubMenu
              key={menuItem.key}
              icon={IconComponent ? <IconComponent /> : null}
              title={menuItem.label}
              disabled={disabled}
            >
              {renderMenuItems(menuItem.subMenu, url)}
            </SubMenu>
          );
        } else {
          return (
            <Menu.Item key={menuItem.key} icon={IconComponent ? <IconComponent /> : null} disabled={disabled}>
            {disabled ? (
              <span style={{ color: 'gray', cursor: 'not-allowed' }}>{menuItem.label}</span>
            ) : (
                <NavLink to={url} activeClassName="ant-menu-item-selected">{menuItem.label}</NavLink>
            )}
            </Menu.Item>
          );
        }
      }
      return null;
    });
  };

  let renderAsmMenuItems = (menuItems, parentUrl = '') => {
    const raw = localStorage.getItem('dashboardFrozen');
    const asmlocalData = raw == 'true';
    const disabled = isRoleASM && asmlocalData;

    menuItems.sort((a, b) => a.priority - b.priority);

    return menuItems.map(item => {
      if (!item.isActive) return null;

      let url = replaceDatePlaceholders(item.url);
      const Icon = iconComponents[item.Icon];

      if (item.subMenu?.length) {
        return (
          <SubMenu key={item.key} icon={Icon ? <Icon /> : null} title={item.label} disabled={disabled}>
            {renderAsmMenuItems(item.subMenu, url)}
          </SubMenu>
        );
      }
      return (
        <Menu.Item key={item.key} icon={Icon ? <Icon /> : null} disabled={disabled}>
          {disabled
            ? <span style={{ color: 'gray', cursor: 'not-allowed' }}>{item.label}</span>
            : <NavLink to={url}>{item.label}</NavLink>
          }
        </Menu.Item>
      );
    });
  };

  let renderOdmAgmMenuItems = (menuItems, parentUrl = '') => {
    const raw = localStorage.getItem('dashboardFrozen');
    const isFrozen = raw === 'true';
    const disabled = isRoleOdmOrAgm && isFrozen;

    menuItems.sort((a, b) => a.priority - b.priority);

    return menuItems.map(item => {
      if (!item.isActive) return null;

      let url = replaceDatePlaceholders(item.url);
      const Icon = iconComponents[item.Icon];

      if (item.subMenu?.length) {
        return (
          <SubMenu key={item.key} icon={Icon ? <Icon /> : null} title={item.label} disabled={disabled}>
            {renderOdmAgmMenuItems(item.subMenu, url)}
          </SubMenu>
        );
      }
      return (
        <Menu.Item key={item.key} icon={Icon ? <Icon /> : null} disabled={disabled}>
          {disabled
            ? <span style={{ color: 'gray', cursor: 'not-allowed' }}>{item.label}</span>
            : <NavLink to={url}>{item.label}</NavLink>
          }
        </Menu.Item>
      );
    });
  };

  const { canAccess } = userDetails?.canAccess?.[0] ?? { canAccess: [] };


  function updateMenuPriority(data) {
    const cloned = JSON.parse(JSON.stringify(data));

    const parentIndex = cloned.findIndex(
      item => item.key === "home_page"
    );

    if (parentIndex !== -1) {
      const [parentItem] = cloned.splice(parentIndex, 1);
      cloned.unshift(parentItem);
    }

    // Update parent priorities
    cloned.forEach((item, index) => {
      item.priority = index + 1;
    });

    const parentMenu = cloned.find(
      item => item.key === "home_page"
    );

    if (parentMenu?.subMenu?.length) {
      const childIndex = parentMenu.subMenu.findIndex(
        item => item.key === "marketing"
      );

      if (childIndex !== -1) {
        const [childItem] = parentMenu.subMenu.splice(childIndex, 1);
        parentMenu.subMenu.unshift(childItem);
      }

      // Update child priorities
      parentMenu.subMenu = parentMenu.subMenu.map((item, index) => ({
        ...item,
        priority: index + 1
      }));
    }

    return cloned;
  }

  // function updateMenuPriorityForDE(data) {
  //   const cloned = JSON.parse(JSON.stringify(data));
  //   const menuIndex = cloned.findIndex(item => item.key === "my-commitment-and-task");
  //   if (menuIndex === -1) return cloned;
    
  //   const [menuItem] = cloned.splice(menuIndex, 1);
  //   cloned.unshift(menuItem);
  //   cloned.forEach((item, index) => {
  //     item.priority = index + 1;
  //   });
  //   return cloned;
  // }

 function updateMenuPriorityForDE(data) {
    const cloned = JSON.parse(JSON.stringify(data));

    const nameToKeyMap = {
      "My commitment & Task": "my-commitment-and-task",
      "Statistics": "dashboard-stats-menu",
      "Design Kick-Off": "design_kick-off",
      "Customer Survey Forms": "view-customer-survey-forms",
      "Approvals": "Approvals",
      "Ticket": "Ticket",
      "Performance Dashboard": "Performance_Dashboard",
      "Reminder": "reminder",
      "Lead Info": "Leadinfo",
      "Knowledge Hub": "knowledge_hub",
      "Download Center": "downloadcenter",
      "Call Detail Recordings": "cdr",
    };

    // Target order from the right side of your image
    const targetOrder = [
      "My commitment & Task",
      "Statistics",
      "Design Kick-off",
      "Customer Survey Forms",
      "Approvals",
      "Ticket",
      "Performance Dashboard",
      "Reminder",
      "Lead Info",
      "Knowledge Hub",
      "Download Center",
      "Call Detail Recordings"
    ];

    // Normalize target order names to match your data keys
    const normalizedTargetOrder = targetOrder.map(name => {
      const normalizedName = Object.keys(nameToKeyMap).find(
        mapKey => mapKey.toLowerCase() === name.toLowerCase()
      );
      return normalizedName ? nameToKeyMap[normalizedName] : name.toLowerCase().replace(/\s+/g, '-');
    });

    // I am sorting based on target priority 
    cloned.sort((a, b) => {
      const aIndex = normalizedTargetOrder.indexOf(a.key);
      const bIndex = normalizedTargetOrder.indexOf(b.key);

      // Handle "My commitment & Task" which should be first
      if (a.key === "my-commitment-and-task") return -1;
      if (b.key === "my-commitment-and-task") return 1;

      // Sort by target order if both are in the list
      if (aIndex !== -1 && bIndex !== -1) {
        return aIndex - bIndex;
      }
      if (aIndex !== -1) return -1;
      return 0;
    });

    // Update priority
    cloned.forEach((item, index) => {
      item.priority = index + 1;
    });

    return cloned;
  }

  // Calling Desk (Calls / Results) sits directly above Statistics. It is not
  // part of the role-managed menu - each child follows Route Access to its page.
  const canOpenCallingDeskCalls = useCanOpenRoute(CALLING_DESK_PATH);
  const canOpenCallingDeskResults = useCanOpenRoute(CALLING_DESK_RESULTS_PATH);
  const withCallingDeskMenu = (menu) => {
    const children = CALLING_DESK_CHILDREN.filter(child => (
      child.url === CALLING_DESK_PATH ? canOpenCallingDeskCalls : canOpenCallingDeskResults
    ));
    if (!children.length || menu.some(item => item.key === CALLING_DESK_MENU_KEY)) return menu;
    const statisticsIndex = menu.findIndex(item => item.key === 'dashboard-stats-menu' || item.label === 'Statistics');
    const withItem = [...menu];
    withItem.splice(statisticsIndex === -1 ? withItem.length : statisticsIndex, 0, {
      key: CALLING_DESK_MENU_KEY,
      label: 'Calling Desk',
      Icon: 'PhoneInTalkIcon',
      url: CALLING_DESK_PATH,
      isActive: true,
      subMenu: children.map(child => ({ ...child })),
    });
    return withItem.map((item, index) => ({ ...item, priority: index + 1 }));
  };

  const manipulatedDataForDE = canAccess ? withCallingDeskMenu(updateMenuPriorityForDE(canAccess)) : [];
  const manipulatedData = canAccess ? withCallingDeskMenu(updateMenuPriority(canAccess)) : [];

  const isActive = (path) => location.pathname === path;


  // Render sidebar content - used in both desktop and mobile views
  const SidebarContent = () => (
    <>
      <div
        className="logo"
        style={{ cursor: 'pointer' }}
        onClick={() => history.push(userDetails?.roles?.find(role => role.name === ROLENAME.TeleCallerUser) ? '/home' : '/dashboard')}
      >
        {collapsed ?
          <img className="decorpot_logo_small" src={decorpotLogoSmall} alt="decorpot logo" /> :
          <img className="decorpot_logo" src={decorpotLogo} alt="decorpot logo" style={{ maxWidth: '130%' }} />
          }
        </div>
      <Menu
        theme="dark"
        mode="inline"
        selectedKeys={selectedKeys}
        openKeys={openKeys}
        onOpenChange={handleOpenChange}
        onClick={handleMenuClick}
      >
        {canAccess && canAccess.length !== 0 ? (
              userDetails?.roles?.some(role => role?.name === "Assistant Sales Manager" || role?.name === "Sales Manager" || role?.name === 'Sales Manager' || role?.name === 'AGM Sales' || role?.name === 'DGM Sales') ? (
                renderAsmMenuItems(manipulatedData)
              ) : userDetails?.roles?.some(role => role?.name === "Operation Design Manager" || role?.name === "AGM Design") ? (
                renderOdmAgmMenuItems(manipulatedData)
              ) : userDetails?.roles?.some(role => role?.name === "Design User") ? (
                renderMenuItems(manipulatedDataForDE)
              ) : (
                renderMenuItems(manipulatedData)
              )
            ) : (
              <Menu.Item key="dashboard" icon={<DashboardOutlined />}>
            <NavLink to="/dashboard" activeClassName="ant-menu-item-selected">
              Home
            </NavLink>
              </Menu.Item>
        )}
        {userDetails?.roles?.find(role =>
          ((role.name !== ROLENAME.ProjectManager ||
          role.name === ROLENAME.SiteInspector ) &&
         (role.name !== ROLENAME.DesignUser && role.name !== ROLENAME.DesignManager &&  role.name !== ROLENAME.DesignHead && role.name !== ROLENAME.DGM_Design && role.name !== ROLENAME.AGM_Design ) )
        ) &&  !hideScanBarcode && (
         <Menu.Item key="scan-code" icon={<DashboardOutlined />}>
         <NavLink to="/scan-piece" activeClassName="ant-menu-item-selected">
            Scan Barcode
            </NavLink>
            </Menu.Item>
        )}

        {userDetails?.roles?.find(role =>
          role.name === ROLENAME.Admin ||
            role.name === ROLENAME.CHM_Manager ||
            role.name === ROLENAME.CHM_User ||
          role.name === ROLENAME.TeleCallerManager 
        ) &&  !hideScanBarcode && (
            <Menu.Item key="CHM-Service-Ticket" icon={<FolderSharedIcon />}>
              <a href="https://decorpotprivatelimited.zohodesk.in/portal/en/newticket" target="_blank" rel="noopener noreferrer">
                Create Service Ticket
              </a>
            </Menu.Item>
          )}
        {userDetails?.email === NarenEmail.email && (
          <Menu.Item key="dso-payment-approval" icon={<DashboardOutlined />}>
            <NavLink to="/dso-payment-approval" activeClassName="ant-menu-item-selected">
              DSO Approval
            </NavLink>
          </Menu.Item>
        )}
      </Menu>
    </>
  );

  return (
    <Layout style={{ minHeight: '100vh' }}>
      {/* Desktop Sidebar */}
      {!isMobile && (
        <Sider
          trigger={null}
          collapsible
          collapsed={collapsed}
          width={300}
          className="desktop-sidebar"
        >
          {SidebarContent()}
        </Sider>
      )}

      {/* Mobile Drawer */}
      {isMobile && (
        <Drawer
          placement="left"
          closable={false}
          onClose={toggleDrawer}
          visible={mobileOpen}
          bodyStyle={{ padding: 0 }}
          width={300}
        >
          <div style={{ backgroundColor: '#001529', height: '100%' }}>
            {SidebarContent()}
          </div>
        </Drawer>
      )}

      <Layout className="site-layout">
        <Header className="site-layout-background" style={{
          padding: 0,
          color: "white",
          position: 'sticky',
          top: 0,
          zIndex: 1000,
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {isMobile ? (
              <Button
                type="text"
                icon={<MenuUnfoldOutlined style={{ color: '#fff' }} />}
                onClick={toggleDrawer}
                className={classes.collapseBtn}
                style={{ padding: '0 18px', fontSize: '18px', color: '#fff' }}
              />
            ) : (
              <Button
                type="text"
                icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                onClick={toggleCollapse}
                className={classes.collapseBtn}
                style={{ padding: '0 18px', fontSize: '18px', color: '#fff' }}
              />
            )}
          </div>

          <div style={{
            display: 'flex',
            alignItems: 'center',
            padding: '0 16px',
            flexWrap: 'wrap',
            justifyContent: 'flex-end'
          }}>
            {!isMobile && (
              <div className={classes.passwordNotice}>
                <span className={classes.passwordNoticeText}>
                  <VpnKeyIcon className={classes.noticeIcon} />
                  Days Remaining
                  <span
                    className={`${classes.daysBadge} ${daysRemainingToChangePassword <= 7 ? classes.daysBadgeUrgent : ''}`}
                  >
                    {daysRemainingToChangePassword}
                  </span>
                </span>
                <Button
                  className={classes.changePasswordButton}
                  onClick={() => setChangePasswordModal(true)}
                  variant="contained"
                >
                  Change Password
              </Button>
          </div>
            )}
            <Tooltip title="Notifications">
              <IconButton
                aria-label="notifications"
                className={classes.headerIconBtn}
                // A toggle, so clicking the bell again shuts the panel rather
                // than re-fetching on the way out.
                onClick={(e) => {
                  if (notifAnchor) { setNotifAnchor(null); return; }
                  setNotifAnchor(e.currentTarget);
                  loadNotifications();
                }}
              >
                <Badge
                  badgeContent={unreadCount}
                  max={99}
                  showZero={false}
                  overlap="circular"
                  classes={{ badge: classes.notifBadge }}
                >
                  {/* Filled bell while something is unread, so the state reads
                      even at a glance away from the badge. */}
                  {unreadCount > 0 ? <NotificationsIcon /> : <NotificationsNoneIcon />}
                </Badge>
              </IconButton>
            </Tooltip>

            <Popper
              open={Boolean(notifAnchor)}
              anchorEl={notifAnchor}
              placement="bottom-end"
              transition
              className={classes.popperRoot}
            >
              {({ TransitionProps }) => (
                <Grow {...TransitionProps} style={{ transformOrigin: 'top right' }}>
                  <Paper elevation={8} className={classes.notifPaper}>
                    {/* ClickAwayListener sits INSIDE the Paper around a plain div,
                  which is the shape MUI documents: it clones its child to
                  attach a ref and a synthetic handler, and a Grow or a Paper
                  would swallow the handler instead of passing it to the DOM. */}
                    <ClickAwayListener
                      onClickAway={(event) => {
                        // A click inside the notification sheet is not a click
                        // away from this panel - the sheet was opened FROM it,
                        // and the panel is deliberately left open behind it so
                        // the next notification is one click away.
                        //
                        // Read off composedPath(), NOT event.target.closest().
                        // The path is captured when the event is dispatched;
                        // `target` is live. By the time this runs, React has
                        // already flushed the state change and unmounted the
                        // sheet's contents (they sit behind `{notification &&
                        // ...}`, which empties the moment the row goes null,
                        // while the Modal shell lingers for the exit
                        // transition). So the clicked button is detached, its
                        // ancestry no longer reaches .MuiDialog-root, closest()
                        // returns null, the guard misses - and the panel closed
                        // itself every time the sheet was dismissed.
                        const path = typeof event.composedPath === 'function' ? event.composedPath() : [];
                        const inSheet = path.some((n) => n && n.classList && n.classList.contains('MuiDialog-root'))
                          // Fallback for browsers without composedPath, where
                          // ClickAwayListener uses contains() anyway.
                          || Boolean(event.target && event.target.closest && event.target.closest('.MuiDialog-root'));
                        if (inSheet) return;
                        setNotifAnchor(null);
                      }}
                    >
                      <div>
                        <div className={classes.notifHead}>
                          <span className={classes.notifHeadTitle}>
                            Notifications
                            {unreadCount > 0 && (
                              <span className={classes.notifHeadCount}>{unreadCount > 99 ? '99+' : unreadCount} new</span>
                            )}
                          </span>
                          {unreadCount > 0 && (
                            <MuiButton size="small" className={classes.notifReadAll} onClick={markAllRead}>
                              Mark all read
                            </MuiButton>
                          )}
                        </div>

                        {/* Jira-style filter. Client-side over what is already loaded,
                            so flipping it costs no request. */}
                        <div className={classes.notifFilterBar}>
                          <FormControlLabel
                            className={classes.notifFilterLabel}
                            control={
                              <IconSwitch
                                checked={onlyUnread}
                                onChange={(e) => setOnlyUnread(e.target.checked)}
                                // The glyph lives inside the knob, so the state is
                                // readable without relying on the track colour alone.
                                icon={<span className={classes.toggleKnob}><ClearIcon style={{ fontSize: 13, color: '#8a8a8a' }} /></span>}
                                checkedIcon={<span className={classes.toggleKnob}><CheckIcon style={{ fontSize: 13, color: '#1e7e34' }} /></span>}
                              />
                            }
                            label={<span className={classes.notifFilterText}>Only show unread</span>}
                          />
                          <span className={classes.notifFilterCount}>
                            {visibleNotifications.length} of {notifications.length}
                          </span>
                        </div>

                        <div className={classes.notifList}>
                          {notifLoading && !notifications.length ? (
                            <div className={classes.notifEmpty}>
                              <CircularProgress size={22} thickness={5} style={{ color: '#c1531f' }} />
                            </div>
                          ) : !visibleNotifications.length ? (
                            <div className={classes.notifEmpty}>
                              {/* Filtered-empty and genuinely-empty are different
                                  situations with different next steps. */}
                              {onlyUnread && notifications.length > 0 ? (
                                <>
                                  <CheckCircleIcon style={{ fontSize: 40, color: '#b7e0c4' }} />
                                  <div className={classes.notifEmptyTitle}>Nothing unread</div>
                                  <div className={classes.notifEmptyHint}>
                                    Turn off the filter to see the last {notifications.length}.
                                  </div>
                                </>
                              ) : (
                                <>
                                  <NotificationsNoneIcon style={{ fontSize: 40, color: '#c9d2de' }} />
                                  <div className={classes.notifEmptyTitle}>You are all caught up</div>
                                  <div className={classes.notifEmptyHint}>Anything sent to you shows up here.</div>
                                </>
                              )}
                            </div>
                          ) : (
                            visibleNotifications.map((n) => {
                              const tone = toneOf(n);
                              return (
                                <div
                                  key={n._id}
                                  className={`${classes.notifRow} ${n.readAt ? '' : classes.notifUnread}`}
                                  onClick={() => openNotification(n)}
                                  style={!n.readAt ? { boxShadow: `inset 3px 0 0 0 ${tone.color}` } : undefined}
                                >
                                  <span className={classes.notifDot} style={{ background: n.readAt ? '#d6d2cf' : tone.color }} />
                                  <div style={{ minWidth: 0, flex: 1 }}>
                                    <div className={classes.notifTitle}>
                                      {n.categoryName && (
                                        <span
                                          className={classes.notifCatChip}
                                          style={{ background: tone.soft, color: tone.deep }}
                                        >
                                          {n.categoryName}
                                        </span>
                                      )}
                                      {n.title}
                                      {n.link && <OpenInNewIcon className={classes.notifLinkIcon} />}
                                    </div>
                                    {/* The editor's own HTML. Only the tech team can author a
                                        notification and the server enforces that, so this is
                                        first-party markup, not user content - but it is still
                                        limited to what the Quill toolbar can produce. */}
                                    {n.messageHtml
                                      ? <div className={classes.notifBody} dangerouslySetInnerHTML={{ __html: n.messageHtml }} />
                                      : <div className={classes.notifBody}>{n.message}</div>}
                                    {n.attachments && n.attachments.length > 0 && (
                                      <div className={classes.notifFiles}>
                                        <AttachFileIcon style={{ fontSize: 13 }} />
                                        {n.attachments.length} attachment{n.attachments.length === 1 ? '' : 's'}
                                      </div>
                                    )}
                                    <div className={classes.notifMeta}>
                                      {n.sentBy && (
                                        <span className={classes.notifSender}>
                                          {String(n.sentBy).trim().charAt(0).toUpperCase()}
                                        </span>
                                      )}
                                      {n.sentBy ? `${n.sentBy} · ` : ''}{moment(n.sentAt).fromNow()}
                                    </div>
                                  </div>
                                </div>
                              );
                            })
                          )}
                        </div>
                      </div>
                    </ClickAwayListener>
                  </Paper>
                </Grow>
              )}
            </Popper>

            {/* Full message, as a full-page sheet sliding up from the bottom.
                Shared with the Sent tab of pages/sendNotification so the two
                cannot drift - see components/NotificationDetailSheet.

                Rendered from the row the panel already holds, so opening it
                costs no request: /mine returns the body, the attachments and
                the sender along with the list. */}
            <NotificationDetailSheet
              notification={detailNotif}
              onClose={() => setDetailNotif(null)}
            />

            {/* The avatar IS the account button now - the name and the gear
                beside it were three elements doing one job. The name moves to
                the tooltip so it stays reachable without holding bar width. */}
            <Tooltip title={userDetails?.name || 'Account'}>
              <IconButton
                aria-label="account settings"
                aria-controls="long-menu"
                aria-haspopup="true"
                className={classes.avatarButton}
                onClick={handleClick}
              >
                <span className={classes.userAvatar}>
                  {String(userDetails?.name || '?').trim().charAt(0).toUpperCase()}
                </span>
              </IconButton>
            </Tooltip>
          </div>
        </Header>

        { (location.pathname === '/dashboard' ||  location.pathname === '/performance_target' || location.pathname === '/stage-review' || location.pathname === '/meeting-tracker' || location.pathname === '/rnc-revival' || location.pathname === '/sales-lost-revival' || location.pathname === '/lead-health-analytics') && userRoles.find((role) =>
          role?.name === 'Sales User' ||
          role?.name === 'Assistant Sales Manager' ||
          role?.name === 'Sales Manager' ||
          role?.name === 'DGM Sales' ||
          role?.name === 'AGM Sales'
        ) &&
          <AppBar position="static"
            color="transparent"
          >
            <Toolbar variant="dense">
              <div style={{
                display: 'flex', gap: '30px', cursor: 'pointer',
                opacity: isRoleSE
                  ? (salesUserDashboardDisable() ? 0.4 : 1)
                  : isRoleASM
                    ? (asmDashboardDisable() ? 0.4 : 1)
                    : '',
                pointerEvents: isRoleSE
                  ? (salesUserDashboardDisable() ? 'none' : 'auto')
                  : isRoleASM
                    ? (asmDashboardDisable() ? 'none' : 'auto')
                    : 'auto'
              }}>
                {userRoles.find((role) => role?.name === 'Sales User' || role?.name === 'Assistant Sales Manager' || role?.name === 'Sales Manager' || role?.name === 'AGM Sales' || role?.name === 'DGM Sales') &&
                  <>
                    <Button style={{ border: 'none', borderRight: '1px solid #ccc', paddingRight: '25px', paddingLeft: '18px', backgroundColor: isActive('/dashboard') ? '#F47E46' : 'transparent'}}>
                      <Link to={`/dashboard`} style={{ color: '#1C375D', fontSize: '15px', fontWeight: 'bold' }} rel="noopener noreferrer"> Dashboard </Link>
                    </Button>
                    <Button style={{ border: 'none', borderRight: '1px solid #ccc', paddingRight: '25px', paddingLeft: '18px', backgroundColor: isActive('/performance_target') ? '#F47E46' : 'transparent' }}>
                      <Link to={`/performance_target`} style={{ color: '#1C375D', fontSize: '15px', fontWeight: 'bold' }} rel="noopener noreferrer"> Performance vs Target </Link>
                    </Button>
                    <Button style={{ border: 'none', borderRight: '1px solid #ccc', paddingRight: '25px',  paddingLeft: '18px', backgroundColor: isActive('/stage-review') ? '#F47E46' : 'transparent' }}>
                      <Link to={`/stage-review`} style={{ color: '#1C375D', fontSize: '15px', fontWeight: 'bold' }} rel="noopener noreferrer"> Stage Review </Link>
                    </Button>
                    <Button style={{ border: 'none', borderRight: '1px solid #ccc', paddingRight: '25px',  paddingLeft: '18px', backgroundColor: isActive('/meeting-tracker') ? '#F47E46' : 'transparent' }}>
                      <Link to={`/meeting-tracker`} style={{ color: '#1C375D', fontSize: '15px', fontWeight: 'bold' }} rel="noopener noreferrer"> Meeting Tracker </Link>
                    </Button>
                    <Button style={{ border: 'none', borderRight: '1px solid #ccc', paddingRight: '25px',  paddingLeft: '18px', backgroundColor: isActive('/rnc-revival') ? '#F47E46' : 'transparent' }}>
                      <Link to={`/rnc-revival`} style={{ color: '#1C375D', fontSize: '15px', fontWeight: 'bold' }} rel="noopener noreferrer"> RNC Revival </Link>
                    </Button>
                    <Button style={{ border: 'none', borderRight: '1px solid #ccc', paddingRight: '25px',  paddingLeft: '18px', backgroundColor: isActive('/sales-lost-revival') ? '#F47E46' : 'transparent' }}>
                      <Link to={`/sales-lost-revival`} style={{ color: '#1C375D', fontSize: '15px', fontWeight: 'bold' }} rel="noopener noreferrer"> Sales Lost Revival </Link>
                    </Button>
                    <Button style={{ borderRight: '1px solid #ccc', paddingRight: '25px',  paddingLeft: '18px', backgroundColor: isActive('/lead-health-analytics') ? '#F47E46' : 'transparent' }}>
                      <Link to={`/lead-health-analytics`} style={{ color: '#1C375D', fontSize: '14px', fontWeight: 'bold' }} rel="noopener noreferrer"> Lead Health Analytics </Link>
                    </Button>
                  </>
                }
              </div>
            </Toolbar>
          </AppBar>
        }

        <Content
          className="site-layout-background"
          style={{
            margin: '16px',
            padding: isMobile ? 12 : 24,
            minHeight: 280,
            overflow: 'auto',
            transition: 'all 0.3s ease' // Add smooth transition
          }}
        >
          <div className="route-content-wrapper" style={{
            opacity: 1,
            transition: 'opacity 0.3s ease-in-out'
          }}>
          <Routes {...props} />
          </div>
        </Content>

        {/* User Menu.
            Popper, not MaterialMenu: a Menu anchors over its trigger, so it
            covered the avatar that opened it. A panel anchored to the
            trigger's bottom-right drops beneath it, matching the notification
            panel next to it. */}
        <Popper
          id="long-menu"
          anchorEl={anchorEl}
          open={open}
          placement="bottom-end"
          transition
          className={classes.popperRoot}
        >
          {({ TransitionProps }) => (
            <Grow {...TransitionProps} style={{ transformOrigin: 'top right' }}>
              <Paper elevation={8} className={classes.userMenuPaper}>
                <ClickAwayListener onClickAway={handleClose}>
                  <div>
                    {/* Says whose account this is - the avatar alone is one letter. */}
                    <div className={classes.userMenuHead}>
                      <span className={classes.userMenuAvatar}>
                        {String(userDetails?.name || '?').trim().charAt(0).toUpperCase()}
                      </span>
                      <div style={{ minWidth: 0 }}>
                        <div className={classes.userMenuName}>{userDetails?.name || 'Signed in'}</div>
                        {userDetails?.email && <div className={classes.userMenuMail}>{userDetails.email}</div>}
                      </div>
                    </div>

                    <MenuItem className={classes.userMenuItem} onClick={() => {
                      handleClose();
                      setProfileModal(true);
                    }}>
                      <AccountCircleIcon className={classes.menuItemIcon} />
                      Profile
                    </MenuItem>
                    <MenuItem className={classes.userMenuItem} onClick={() => {
                      handleClose();
                      setChangePasswordModal(true);
                    }}>
                      <VpnKeyIcon className={classes.menuItemIcon} />
                      Change password
                    </MenuItem>
                    <MenuItem className={`${classes.userMenuItem} ${classes.userMenuDanger}`} key={'logout'} onClick={() => {
                      handleClose();
                      setLogoutConfirmModal(true);
                    }}>
                      <ExitToAppIcon className={classes.menuItemIcon} />
                      Logout
                    </MenuItem>
                  </div>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>

        {/* Chat Widget */}
        {!showChatComponent && <GroupChatWidgetIcon onClick={handleChatIconClick} />}
         <Dialog
          open={showChatComponent}
          onClose={handleCloseChat}
          PaperProps={{
            style: {
              position: 'fixed',
              bottom: '70px',
              right: '20px',
              margin: 0,
              width: isMobile ? '90%' : '30%',
              maxHeight: '60%',
              borderRadius: '10px',
              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
            },
          }}
          hideBackdrop
          disableEnforceFocus
          disableEscapeKeyDown
        >
          <GroupChat onClose={handleCloseChat} />
      </Dialog>
      <Dialog
        open={changePasswordModal}
        TransitionComponent={Transition}
        keepMounted
        fullWidth={true}
        maxWidth={'xs'}
        onClose={() => setChangePasswordModal(false)}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <div className={classes.dlgHead}>
          <div className={classes.dlgHeadIcon}><VpnKeyIcon /></div>
          <div className={classes.dlgHeadText}>
            <div className={classes.dlgTitle}>Change Password</div>
            <div className={classes.dlgSub}>
              {daysRemainingToChangePassword <= 7
                ? `Expires in ${daysRemainingToChangePassword} day${daysRemainingToChangePassword === 1 ? '' : 's'}`
                : 'Pick something you have not used here before'}
            </div>
          </div>
          <IconButton size="small" aria-label="Close" className={classes.dlgClose} onClick={() => handleCancelForChangePassword()}>
            <ClearIcon />
          </IconButton>
        </div>
        <DialogContent className={classes.dlgBody}>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <TextField
              style={{ marginBottom: 12 }} label="Current Password" name="currentPassword"
              variant="outlined" size="small" fullWidth
              type={showPw.current ? 'text' : 'password'}
              value={password.currentPassword} onChange={changeHandler}
              InputProps={{ endAdornment: pwToggle('current') }}
            />
            <TextField
              style={{ marginBottom: 6 }} label="New Password" name="newPassword"
              variant="outlined" size="small" fullWidth
              type={showPw.next ? 'text' : 'password'}
              value={password.newPassword} onChange={changeHandler}
              error={password.newPassword.length > 0 && isPasswordShort}
              helperText={password.newPassword.length > 0 && isPasswordShort ? 'Must be at least 8 characters' : ' '}
              InputProps={{ endAdornment: pwToggle('next') }}
            />

            {/* The strength word on its own gave no sense of distance to the
                next level, and "Weak" in pale green read as a pass. */}
            {password.newPassword.length > 0 && (
              <div className={classes.strengthWrap}>
                <div className={classes.strengthTop}>
                  <span>Strength</span>
                  <span style={{ color: strengthMeter.color, textTransform: 'none', fontSize: 12.5 }}>
                    {passwordStrength}
                  </span>
                </div>
                <div className={classes.strengthTrack}>
                  <div
                    className={classes.strengthFill}
                    style={{ width: `${strengthMeter.pct}%`, background: strengthMeter.color }}
                  />
                </div>
              </div>
            )}

            <TextField
              style={{ marginBottom: 12 }} label="Confirm Password" name="confirmPassword"
              variant="outlined" size="small" fullWidth
              type={showPw.confirm ? 'text' : 'password'}
              value={password.confirmPassword} onChange={changeHandler}
              error={password.confirmPassword.length > 0 && !isConfirmPasswordMatched}
              helperText={password.confirmPassword.length > 0 && !isConfirmPasswordMatched ? 'Passwords do not match' : ' '}
              InputProps={{ endAdornment: pwToggle('confirm') }}
            />

            {/* Was "Atleast 1 Uppercase : No" in red - a checklist of things
                not yet done should not look like four errors. */}
            {password.newPassword.length > 0 && (
              <div className={classes.ruleGrid}>
                {[
                  ['1 uppercase letter', isPasswordValidated.hasUpperCase],
                  ['1 lowercase letter', isPasswordValidated.hasLowerCase],
                  ['1 number', isPasswordValidated.hasNumber],
                  ['1 special character', isPasswordValidated.hasSpecialChar],
                  ['8 characters or more', !isPasswordShort],
                ].map(([label, met]) => (
                  <span key={label} className={`${classes.rule} ${met ? classes.ruleMet : classes.ruleUnmet}`}>
                    {met
                      ? <CheckCircleIcon style={{ fontSize: 16, color: '#17803d' }} />
                      : <RadioButtonUncheckedIcon style={{ fontSize: 16, color: '#c3bdb8' }} />}
                    {label}
                  </span>
                ))}
              </div>
            )}
          </div>
        </DialogContent>
        <DialogActions className={classes.dlgActions}>
          <MuiButton onClick={() => handleCancelForChangePassword()} className={classes.btnGhost}>
            Cancel
          </MuiButton>
          <MuiButton
            onClick={changePassword}
            className={classes.btnPrimary}
            startIcon={<VpnKeyIcon style={{ fontSize: 17 }} />}
            disabled={password.currentPassword === "" || password.newPassword === "" || password.confirmPassword === "" || isPasswordShort || !isConfirmPasswordMatched || ['Very Weak', 'Weak'].includes(passwordStrength)}
          >
            Update Password
          </MuiButton>
        </DialogActions>
      </Dialog>
      <Dialog
          open={profileModal}
            TransitionComponent={Transition}
          onClose={() => setProfileModal(false)}
          maxWidth="sm"
          fullWidth
          classes={{ paper: classes.profileDialogPaper }}
        >
        <div className={classes.profileHeader}>
          <IconButton
            className={classes.profileHeaderClose}
            size="small"
            onClick={() => setProfileModal(false)}
          >
            <CloseOutlined style={{ fontSize: 15 }} />
          </IconButton>
          <div className={classes.profileAvatar}>
            {(userDetails?.name || '').split(' ').filter(Boolean).slice(0, 2).map(part => part[0]).join('').toUpperCase() || '?'}
          </div>
          <div className={classes.profileHeaderText}>
            <div className={classes.profileHeaderName}>{userDetails?.name || 'Not available'}</div>
            <div className={classes.profileHeaderRoleList}>
              {userRoles.length ? (
                userRoles.map((role) => (
                  <span className={classes.profileHeaderRole} key={role._id || role.name}>{role.name}</span>
                ))
              ) : (
                <span className={classes.profileHeaderRole}>Not available</span>
              )}
            </div>
          </div>
        </div>
      <DialogContent className={classes.profileBody}>
        <div className={classes.profileSection}>
          <div className={classes.profileSectionTitle}>Contact Details</div>
          <div className={classes.profileGrid}>
            <div className={`${classes.profileCard} ${classes.profileCardFull}`}>
              <div className={classes.profileCardIcon}><IoMail /></div>
              <div style={{ minWidth: 0, flex: 1 }}>
                <div className={classes.profileCardTop}>
                  <div>
                    <div className={classes.profileCardLabel}>Email</div>
                    <div className={classes.profileCardValue}>{userDetails?.email || 'Not available'}</div>
                  </div>
                  {userDetails?.email && (
                    <Tooltip title="Copy email">
                      <IconButton
                        className={classes.profileCopyBtn}
                        size="small"
                        onClick={() => copyProfileValue(userDetails.email, 'Email')}
                      >
                        <CopyOutlined style={{ fontSize: 14 }} />
                      </IconButton>
                    </Tooltip>
                  )}
                </div>
              </div>
            </div>

            <div className={`${classes.profileCard} ${classes.profileCardFull}`}>
              <div className={classes.profileCardIcon}><PhoneOutlined /></div>
              <div style={{ minWidth: 0, flex: 1 }}>
                <div className={classes.profileCardTop}>
                  <div>
                    <div className={classes.profileCardLabel}>Mobile Number</div>
                    <div className={classes.profileCardValue}>{userDetails?.mobile || 'Not available'}</div>
                  </div>
                  {userDetails?.mobile && (
                    <Tooltip title="Copy mobile number">
                      <IconButton
                        className={classes.profileCopyBtn}
                        size="small"
                        onClick={() => copyProfileValue(userDetails.mobile, 'Mobile number')}
                      >
                        <CopyOutlined style={{ fontSize: 14 }} />
                      </IconButton>
                    </Tooltip>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={classes.profileSection}>
          <div className={classes.profileSectionTitle}>Work Information</div>
          <div className={classes.profileGrid}>
            <div className={classes.profileCard}>
              <div className={classes.profileCardIcon}><BankOutlined /></div>
              <div style={{ minWidth: 0 }}>
                <div className={classes.profileCardLabel}>Department</div>
                <div className={classes.profileCardValue}>{departmentName || 'Not available'}</div>
              </div>
            </div>
            <div className={classes.profileCard}>
              <div className={classes.profileCardIcon}><UsergroupAddOutlined /></div>
              <div style={{ minWidth: 0 }}>
                <div className={classes.profileCardLabel}>Team</div>
                <div className={classes.profileCardValue}>{userDetails?.teamId?.name || 'Not available'}</div>
              </div>
            </div>
            {assistantManager ?
            <div className={classes.profileCard}>
              <div className={classes.profileCardIcon}><IdcardOutlined /></div>
              <div style={{ minWidth: 0 }}>
                <div className={classes.profileCardLabel}>Assistant Manager</div>
                <div className={classes.profileCardValue}>{assistantManager || 'Not available'}</div>
              </div>
             </div>:""}
             {userDetails?.teamId?.manager?.name?
            <div className={classes.profileCard}>
              <div className={classes.profileCardIcon}><CrownOutlined /></div>
              <div style={{ minWidth: 0 }}>
                <div className={classes.profileCardLabel}>Manager</div>
                <div className={classes.profileCardValue}>{userDetails?.teamId?.manager?.name || 'Not available'}</div>
              </div>
            </div>:""}
          </div>
        </div>

        <div className={classes.profileSection}>
          <div className={classes.profileSectionTitle}>Coverage Areas</div>
          <div className={classes.profileGrid}>
            <div className={`${classes.profileCard} ${classes.profileCardFull}`}>
              <div className={classes.profileCardIcon}><EnvironmentOutlined /></div>
              <div style={{ minWidth: 0 }}>
                <div className={classes.profileCardLabel}>Locations</div>
                {userDetails?.locationId?.length ? (
                  <div className={classes.profileChipList}>
                    {userDetails.locationId.map(locationId => (
                      <span className={classes.profileChip} key={locationId._id || locationId.name}>{locationId.name}</span>
                    ))}
                  </div>
                ) : (
                  <div className={classes.profileCardValue}>Not available</div>
                )}
              </div>
            </div>
            <div className={`${classes.profileCard} ${classes.profileCardFull}`}>
              <div className={classes.profileCardIcon}><ShopOutlined /></div>
              <div style={{ minWidth: 0 }}>
                <div className={classes.profileCardLabel}>Experience Centers</div>
                {experienceCenter?.length ? (
                  <div className={classes.profileChipList}>
                    {experienceCenter.map(expcenters => (
                      <span className={classes.profileChip} key={expcenters._id || expcenters.name}>{expcenters.name}</span>
                    ))}
                  </div>
                ) : (
                  <div className={classes.profileCardValue}>Not available</div>
                )}
              </div>
            </div>
          </div>
        </div>
      </DialogContent>
      <DialogActions style={{ padding: '14px 24px 20px' }}>
        <Button className={classes.profileCloseButton} onClick={() => setProfileModal(false)}>
          Close
        </Button>
      </DialogActions>

    </Dialog>
             {/* Logout Confirmation Dialog */}
        <Dialog
        open={logoutConfirmModal}
        TransitionComponent={Transition}
        onClose={() => setLogoutConfirmModal(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <div className={`${classes.dlgHead} ${classes.dlgHeadDanger}`}>
          <div className={classes.dlgHeadIcon}><ExitToAppIcon /></div>
          <div className={classes.dlgHeadText}>
            <div className={classes.dlgTitle} id="alert-dialog-title">Log out?</div>
            <div className={classes.dlgSub}>You will need to sign in again to continue</div>
          </div>
          <IconButton size="small" aria-label="Close" className={classes.dlgClose} onClick={() => setLogoutConfirmModal(false)}>
            <ClearIcon />
          </IconButton>
        </div>
        <DialogContent className={classes.dlgBody}>
          <DialogContentText id="alert-dialog-description" style={{ marginBottom: 4, fontSize: 14 }}>
            Any unsaved work on this page will be lost.
          </DialogContentText>
          {/* Says WHO is being signed out - this app is shared on floor
              machines, where that is not always the person clicking. */}
          <div className={classes.logoutUser}>
            <span className={classes.logoutAvatar}>
              {String(userDetails?.name || '?').trim().charAt(0).toUpperCase()}
            </span>
            <div style={{ minWidth: 0 }}>
              <div className={classes.logoutName}>{userDetails?.name || 'Signed in user'}</div>
              {userDetails?.email && <div className={classes.logoutMail}>{userDetails.email}</div>}
            </div>
          </div>
        </DialogContent>
        <DialogActions className={classes.dlgActions}>
          <MuiButton onClick={() => setLogoutConfirmModal(false)} className={classes.btnGhost} autoFocus>
            Stay signed in
          </MuiButton>
          <MuiButton onClick={logout} className={classes.btnDanger} startIcon={<ExitToAppIcon style={{ fontSize: 17 }} />}>
            Log out
          </MuiButton>
        </DialogActions>
      </Dialog>
      </Layout>
      {/* <CacheClearAlert directive={cacheDirective} remainingMs={cacheClearRemainingMs} /> */}
    </Layout>

  )
})

export default connect(null, { setLoading, setSnackInfo, setUserDetails })(Sidebar)